
























































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {NotificationStore} from "@/modules/notifications/store";
import {EmployeeType, NotificationTargetType, NotificationType} from "@/enums/type";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeStore} from "@/modules/employees/store";
import number from "vue-i18n/src/components/number";

const form = {
    title: undefined,
    description: undefined,
    content: undefined,
    type: NotificationType.Basic,
    targetType: undefined,
    accountRowGuid: undefined,
    employeeRowGuid: undefined
};
@Component({
    name: "NotificationEmployeeForm",
    components: {EmployeeSelector}
})
export default class extends Vue {
    EmployeeType = EmployeeType;

    private form = { ...form };

    private rules = {
        title: [{ required: true, message: "Nhập tiêu đề", trigger: "change" }],
        description: [{ required: true, message: "Nhập mô tả", trigger: "change" }],
        content: [{ required: true, message: "Nhập nội dung", trigger: "change" }],
    };

    private onSubmit() {
        (this.$refs.formNotification as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                if (this.form.employeeRowGuid) {
                    this.form.accountRowGuid = EmployeeStore.data[this.form.employeeRowGuid as any]?.accountRowGuid as any
                    this.form.targetType = NotificationTargetType.Single as any;
                } else {
                    this.form.targetType = NotificationTargetType.Employee as any;
                }
                await NotificationStore.createNotification(this.form);
                this.$message.success("Gửi thông báo thành công");
                this.form = { ...form };
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `Gửi thông báo thất bại`}`)
            }
        })
    }
}
